import { render, staticRenderFns } from "./Macro.vue?vue&type=template&id=63aa87d4&scoped=true&"
import script from "./Macro.vue?vue&type=script&lang=ts&"
export * from "./Macro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63aa87d4",
  null
  
)

export default component.exports